import { LinkTarget } from './types';

export function openExternalLinkInNewTab(url: string) {
  openExternalLink(url, '_blank');
}

export function openExternalLink(url: string, target: LinkTarget) {
  window.open(url, target) || window.location.replace(url);
}
